// Core i18next library.
import i18n from "i18next";
// Bindings for React: allow components to
// re-render when language changes.
import {initReactI18next} from "react-i18next";
import HttpApi from "i18next-http-backend";
import {VivoPortal} from "@utils/AppConstants";
import languageList = VivoPortal.languageList;
import LanguageDetector from "i18next-browser-languagedetector";


export const supportedLanguages = languageList.reduce((acc, language) => {
    acc[language.IdString] = language.Name;
    return acc;
}, {} as { [key: string]: string });

i18n
    .use(HttpApi)
    .use(LanguageDetector)
    // Add React bindings as a plugin.
    .use(initReactI18next)
    // Initialize the i18next instance.
    .init({
        // Config options
        //
        //
        // // Specifies the default language (locale) used
        // // when a user visits our site for the first time.
        // // We use English here, but feel free to use
        // // whichever locale you want.
        // lng: "en",

        // Fallback locale used when a translation is
        // missing in the active locale. Again, use your
        // preferred locale here.
        fallbackLng: "en",
        backend: {
            queryStringParams: { v: process.env.REACT_APP_VERSION },
        },
        // supported locales.
        supportedLngs: Object.keys(supportedLanguages),
        // Enables useful output in the browser’s
        // dev console.
        debug:  process.env.REACT_APP_DEVELOPMENT_MODE === 'true',
        detection: {
            order: ['path', 'cookie', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
        },
        react: {
            useSuspense: false,
        },
        // Normally, we want `escapeValue: true` as it
        // ensures that i18next escapes any code in
        // translation messages, safeguarding against
        // XSS (cross-site scripting) attacks. However,
        // React does this escaping itself, so we turn 
        // it off in i18next.
        interpolation: {
            escapeValue: false,
        }});

export default i18n;